<template>
  <v-app style="background-color: #f8f9fb">
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Carregando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Nova Versão -->
    <v-dialog v-model="novaVersaoDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          Nova versão do arquivo
        </v-card-title>
        <v-card-text class="pt-4">
          <v-textarea
            v-model="novaVersaoDescricao"
            label="Descrição da versão"
            placeholder="Ex: Correção do item 3.2"
            outlined
            dense
            rows="3"
          ></v-textarea>
          <v-file-input
            v-model="novaVersaoArquivo"
            label="Arquivo"
            prepend-icon="mdi-paperclip"
            outlined
            dense
            show-size
            :accept="'.pdf,.png,.jpg,.jpeg,.docx,.xls,.xlsx'"
            :rules="[(v) => !!v || 'Selecione um arquivo']"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="fecharNovaVersaoDialog">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="salvandoVersao"
            :disabled="!novaVersaoDescricao || !novaVersaoArquivo"
            @click="cadastrarVersao"
          >
            Enviar versão
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmação para exclusão -->
    <v-dialog v-model="confirmDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline primary white--text">
          Confirmação
        </v-card-title>
        <v-card-text class="pt-4">
          {{ confirmMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="confirmDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="red" text @click="confirmAction"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="permissoesDialog" max-width="1000px" persistent>
      <v-card>
        <v-card-title class="headline primary white--text text-center py-4">
          Acesso ao Arquivo
        </v-card-title>

        <v-card-text class="pt-4" style="min-height: 200px">
          <v-select
            v-model="tipoPermissao"
            :items="['Grupo', 'Usuário']"
            label="Tipo de permissão"
            outlined
            dense
            hide-details
          ></v-select>

          <!-- Tabela de grupos -->
          <div v-if="tipoPermissao === 'Grupo'" class="mt-2">
            <v-row>
              <v-col cols="6" md="6"></v-col>
              <v-col cols="6" md="6" class="d-flex justify-end py-0"
                ><v-text-field
                  v-model="search"
                  label="Buscar..."
                  append-icon="mdi-magnify"
                  dense
                  hide-details
                  outlined
                  class="my-4"
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="12" class="px-0 py-0"
                ><v-data-table
                  height="40vh"
                  :headers="headersGrupos"
                  :items="listaGrupos"
                  :search="search"
                  item-key="grupo.id"
                  show-select
                  item-per-page="10"
                  v-model="gruposSelecionados"
                  dense
                  class="elevation-0"
                >
                  <template v-slot:item.colaboradores="{ item }">
                    {{ item.colaboradores.length }}
                  </template>
                </v-data-table></v-col
              >
            </v-row>
          </div>

          <!-- Tabela de usuários/colaboradores -->
          <div v-else-if="tipoPermissao === 'Usuário'" class="mt-2">
            <v-row>
              <v-col cols="6" md="6"></v-col>
              <v-col cols="6" md="6" class="d-flex justify-end py-0"
                ><v-text-field
                  v-model="search"
                  label="Buscar..."
                  append-icon="mdi-magnify"
                  dense
                  hide-details
                  outlined
                  class="my-4"
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="12" class="px-0 py-0">
                <v-data-table
                  height="40vh"
                  fixed-header
                  :headers="headersColaboradores"
                  :items="listaColaboradores"
                  :search="search"
                  item-key="id"
                  show-select
                  :items-per-page="10"
                  v-model="colaboradoresSelecionados"
                  dense
                  class="elevation-0"
                ></v-data-table
              ></v-col>
            </v-row>
          </div>

          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey lighten-1">mdi-account-group</v-icon>
            <div class="grey--text mt-4">
              Selecione um tipo para visualizar os colaboradores
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="
              permissoesDialog = false;
              tipoPermissao = '';
              search = '';
            "
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="previewDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="preview-dialog">
        <v-toolbar dark color="primary" class="preview-toolbar">
          <v-toolbar-title>Visualização do Arquivo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="previewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="preview-content pa-0">
          <iframe
            v-if="previewUrl"
            :src="previewUrl"
            :type="previewType"
            class="preview-iframe"
            frameborder="0"
            @load="handleIframeLoad"
            @error="handleIframeError"
          ></iframe>
          <div v-else class="preview-error">
            <v-alert type="error" dense>
              Erro ao carregar o preview do arquivo. Por favor, tente novamente.
            </v-alert>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog para adicionar/editar comentário -->
    <v-dialog v-model="comentarioDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="headline primary white--text text-center py-4">
          {{ editingComentario.id ? "Editar Comentário" : "Novo Comentário" }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-textarea
            v-model="editingComentario.descricao"
            label="Descrição"
            outlined
            auto-grow
            rows="4"
            counter="500"
            maxlength="500"
            :rules="[(v) => !!v || 'Descrição é obrigatória']"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeComentarioDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :loading="savingComentario"
            :disabled="!editingComentario.descricao"
            @click="saveComentario"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="background-color: #eee" fluid tag="section">
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-file-plus"
            title="Consulta de Arquivo"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-4"
          >
            <v-container>
              <v-row>
                <v-col cols="12" md="6" class="pb-0"
                  ><div class="d-flex mb-6">
                    <v-btn
                      color="primary"
                      text
                      @click="voltar"
                      class="text-capitalize font-weight-medium"
                    >
                      <v-icon left size="20">mdi-arrow-left</v-icon>
                      Voltar
                    </v-btn>
                  </div></v-col
                >
                <v-col cols="12" md="6" class="pb-0 d-flex justify-end"
                  ><div class="d-flex mb-6" v-if="!semPermissao">
                    <v-btn
                      width="130"
                      height="32"
                      small
                      color="primary"
                      @click="previewFile(documento)"
                    >
                      <v-icon left>mdi-eye</v-icon>
                      Visualizar
                    </v-btn>
                    <v-btn
                      width="130"
                      height="32"
                      small
                      color="primary"
                      @click="downloadFile(documento)"
                    >
                      <v-icon left>mdi-download</v-icon>
                      Baixar
                    </v-btn>
                  </div></v-col
                >
              </v-row>

              <!-- Alerta de erro de permissão -->
              <v-alert
                v-if="semPermissao"
                type="error"
                prominent
                border="left"
                class="my-6"
              >
                <v-row align="center">
                  <v-col class="grow">
                    <div class="text-h6 mb-2">
                      <v-icon left color="error">mdi-lock</v-icon>
                      Acesso Negado
                    </div>
                    <div>{{ mensagemErroPermissao }}</div>
                  </v-col>
                </v-row>
              </v-alert>

              <v-tabs color="secondary" left v-if="!semPermissao">
                <v-tab class="text-capitalize" width="130" height="32"
                  >Detalhes</v-tab
                >
                <v-tab class="text-capitalize" width="130" height="32"
                  >Permissões</v-tab
                >
                <v-tab class="text-capitalize" width="130" height="32"
                  >Comentários</v-tab
                >
                <v-tab class="text-capitalize" width="130" height="32"
                  >Histórico</v-tab
                >

                <v-tab-item>
                  <!-- Categorização -->
                  <v-card class="mb-6 card-section" outlined elevation="0">
                    <v-card-title class="section-header">
                      <v-icon color="orange" class="mr-2"
                        >mdi-tag-outline</v-icon
                      >
                      <span class="subtitle-1 font-weight-bold"
                        >Categorização</span
                      >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-6">
                      <v-row>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            v-model="documento.empresa"
                            label="Empresa"
                            readonly
                            outlined
                            dense
                            required
                            prepend-inner-icon="mdi-domain"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            v-model="documento.departamento"
                            readonly
                            label="Departamento"
                            outlined
                            dense
                            prepend-inner-icon="mdi-office-building"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            v-model="documento.categoria"
                            readonly
                            label="Categoria"
                            outlined
                            dense
                            required
                            prepend-inner-icon="mdi-bookmark-outline"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            v-model="documento.subCategoria"
                            readonly
                            label="Subcategoria"
                            outlined
                            dense
                            prepend-inner-icon="mdi-bookmark-multiple-outline"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0 pt-0">
                          <v-text-field
                            v-model="documento.palavraChave"
                            label="Palavras-chave"
                            placeholder="Ex: contrato, serviços, fornecedor"
                            outlined
                            readonly
                            dense
                            prepend-inner-icon="mdi-key-outline"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- Informações Básicas -->
                  <v-card class="mb-6 card-section" outlined elevation="0">
                    <v-card-title class="section-header">
                      <v-icon color="blue" class="mr-2"
                        >mdi-information-outline</v-icon
                      >
                      <span class="subtitle-1 font-weight-bold"
                        >Informações Básicas</span
                      >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-6">
                      <v-row>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            v-model="documento.titulo"
                            readonly
                            label="Título do Documento"
                            placeholder="Ex: Contrato de Prestação de Serviços"
                            maxlength="50"
                            counter
                            outlined
                            dense
                            required
                            prepend-inner-icon="mdi-file-document-outline"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            v-model="documento.identificacao"
                            readonly
                            :label="consultarLabelCampoChave"
                            outlined
                            dense
                            prepend-inner-icon="mdi-file-outline"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pb-0">
                          <v-textarea
                            v-model="documento.descricao"
                            label="Descrição"
                            readonly
                            placeholder="Descreva brevemente o conteúdo do documento..."
                            outlined
                            dense
                            rows="3"
                            prepend-inner-icon="mdi-text"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- Informações do Arquivo -->
                  <v-card
                    v-if="documento.id"
                    class="mb-6 card-section"
                    outlined
                    elevation="0"
                  >
                    <v-card-title class="section-header">
                      <v-icon color="green" class="mr-2"
                        >mdi-file-information-outline</v-icon
                      >
                      <span class="subtitle-1 font-weight-bold"
                        >Informações do Arquivo</span
                      >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-6">
                      <v-row>
                        <v-col cols="12" md="4" class="pb-0">
                          <v-text-field
                            v-model="documento.extensao"
                            label="Extensão"
                            readonly
                            outlined
                            dense
                            prepend-inner-icon="mdi-file-outline"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="pb-0">
                          <v-text-field
                            v-model="documento.dimensao"
                            label="Dimensão"
                            readonly
                            outlined
                            dense
                            prepend-inner-icon="mdi-arrow-expand"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="pb-0">
                          <v-text-field
                            v-model="documento.proporcao"
                            label="Proporção"
                            readonly
                            outlined
                            dense
                            prepend-inner-icon="mdi-aspect-ratio"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- Controle de Versão e Datas -->
                  <v-card class="mb-6 card-section" outlined elevation="0">
                    <v-card-title class="section-header">
                      <v-icon color="purple" class="mr-2"
                        >mdi-clock-outline</v-icon
                      >
                      <span class="subtitle-1 font-weight-bold"
                        >Controle de Versão e Datas</span
                      >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-6">
                      <v-row>
                        <v-col cols="12" md="3" class="pb-0">
                          <v-text-field
                            v-model="dataValidadeBR"
                            label="Data de Validade"
                            readonly
                            outlined
                            dense
                            prepend-inner-icon="mdi-calendar"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" class="pb-0">
                          <v-text-field
                            v-model="dataVencimentoBR"
                            label="Data de Vencimento"
                            readonly
                            outlined
                            dense
                            prepend-inner-icon="mdi-calendar-alert"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <!-- Histórico de versões -->
                  <v-card class="mb-6 card-section" outlined elevation="0">
                    <v-card-title class="section-header">
                      <v-icon color="blue" class="mr-2">mdi-history</v-icon>
                      Histórico de versões
                      <v-chip
                        class="ml-2"
                        small
                        color="primary"
                        text-color="white"
                        >{{ versoes.length }}</v-chip
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        small
                        outlined
                        @click="abrirNovaVersaoDialog"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        Nova versão do arquivo
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="py-2 px-0">
                      <v-list dense v-if="versoes.length > 0">
                        <v-list-item
                          v-for="(ver, index) in paginatedVersoes"
                          :key="ver.arquivoId || index"
                          :class="{ 'item-divisor': index > 0 }"
                        >
                          <v-list-item-avatar
                            class="d-flex align-center justify-center"
                          >
                            <v-icon>mdi-file-document-outline</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <div
                              class="d-flex align-center justify-space-between flex-wrap"
                            >
                              <div class="text-body-2">
                                <div>
                                  <strong>Descrição:</strong>
                                  {{ ver.descricao || "—" }}
                                </div>
                                <div>
                                  <strong>Nome:</strong>
                                  {{ ver.nomeArquivo || "—" }}
                                </div>
                                <div>
                                  <strong>Data de criação:</strong>
                                  {{
                                    formatarDataHoraBR(ver.dataInsert) || "—"
                                  }}
                                </div>
                                <div>
                                  <strong>Usuário:</strong>
                                  {{ ver.usuarioInsert || "—" }}
                                </div>
                              </div>
                              <div class="d-flex">
                                <v-btn
                                  text
                                  small
                                  color="secondary"
                                  @click="previewFile(ver)"
                                  title="Visualizar"
                                >
                                  <v-icon small>mdi-eye</v-icon>
                                </v-btn>
                                <v-btn
                                  text
                                  small
                                  color="secondary"
                                  @click="downloadFile(ver)"
                                  title="Baixar"
                                >
                                  <v-icon small>mdi-download</v-icon>
                                </v-btn>
                              </div>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <div v-else class="text-center py-6 grey--text">
                        Nenhuma versão registrada.
                      </div>
                      <v-pagination
                        v-if="versoes.length > itemsPerPage"
                        :total-visible="7"
                        v-model="versoesPage"
                        :length="Math.ceil(versoes.length / itemsPerPage)"
                        class="mb-4"
                        color="primary"
                      />
                    </v-card-text>
                  </v-card>

                  <!-- Lista de documentos vinculados -->
                  <v-card class="mb-6 card-section" outlined elevation="0">
                    <v-card-title class="section-header">
                      <v-icon color="green" class="mr-2"
                        >mdi-link-variant</v-icon
                      >
                      Listagem de documentos vinculados
                      <v-chip
                        class="ml-2"
                        small
                        color="primary"
                        text-color="white"
                        >{{ documentosVinculados.length }}</v-chip
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        small
                        outlined
                        @click="novoArquivoVinculado"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        Novo arquivo vinculado
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="py-2 px-0">
                      <v-list dense v-if="documentosVinculados.length > 0">
                        <!-- Na lista de documentos vinculados -->
                        <v-list-item
                          v-for="(doc, index) in paginatedDocumentosVinculados"
                          :key="index"
                          :class="{ 'item-divisor': index > 0 }"
                        >
                          <v-list-item-avatar
                            class="d-flex align-center justify-center"
                          >
                            <v-icon>mdi-file-document-outline</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <!-- 🔹 CABEÇALHO -->
                            <div
                              class="d-flex align-center justify-space-between"
                            >
                              <div class="d-flex align-center">
                                <span class="font-weight-bold text-subtitle-4">
                                  {{ doc.titulo }}
                                </span>
                              </div>
                              <v-chip
                                small
                                dark
                                :color="
                                  doc.status === 'Ativo' ? 'green' : 'orange'
                                "
                              >
                                {{ doc.status }}
                              </v-chip>
                            </div>

                            <!-- 🔹 INFORMAÇÕES -->
                            <div class="text-body-2">
                              <div><strong>ID:</strong> {{ doc.id }}</div>
                              <div>
                                <strong>Categoria:</strong> {{ doc.categoria }}
                              </div>
                              <div>
                                <strong>Nome do Arquivo:</strong>
                                {{ doc.nomeArquivo }}
                              </div>
                              <div>
                                <strong>Descrição:</strong> {{ doc.descricao }}
                              </div>
                            </div>

                            <!-- 🔹 AÇÕES -->
                            <div class="d-flex mt-2">
                              <v-btn
                                text
                                small
                                color="secondary"
                                @click="abrirArquivoVinculado(doc.id)"
                              >
                                <v-icon left small>mdi-file-eye-outline</v-icon>
                                Visualizar Arquivo
                              </v-btn>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <div v-else class="text-center py-6 grey--text">
                        Nenhum arquivo vinculado encontrado.
                      </div>
                      <v-pagination
                        :total-visible="7"
                        v-if="documentosVinculados.length > itemsPerPage"
                        v-model="documentosVinculadosPage"
                        :length="
                          Math.ceil(documentosVinculados.length / itemsPerPage)
                        "
                        class="mb-4"
                        color="primary"
                      />
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item
                  ><v-card class="mb-6 card-section" outlined elevation="0">
                    <v-card-title class="section-header">
                      <v-row>
                        <v-col cols="10">
                          <v-icon color="green" class="mr-2"
                            >mdi-lock-outline</v-icon
                          >
                          Controle de Acesso
                          <v-chip
                            class="ml-2"
                            small
                            color="primary"
                            text-color="white"
                            >{{
                              gruposSelecionados.length +
                              colaboradoresSelecionados.length
                            }}</v-chip
                          >
                        </v-col>
                        <v-col cols="2" class="d-flex align-center justify-end">
                          <v-btn
                            small
                            color="primary"
                            @click="
                              permissoesDialog = true;
                              consultar_colaboradores();
                              consultar_grupo_colaboradores();
                            "
                          >
                            <v-icon color="white" left>mdi-plus</v-icon>
                            Adicionar permissão
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-divider></v-divider>
                    <!-- Lista de permissões -->
                    <v-card-text class="py-0">
                      <v-list
                        dense
                        v-if="
                          gruposSelecionados.length > 0 ||
                          colaboradoresSelecionados.length > 0
                        "
                      >
                        <!-- Na lista de documentos vinculados -->
                        <v-list-item
                          v-for="(item, index) in gruposSelecionados"
                          :key="item.id || index"
                        >
                          <v-list-item-avatar>
                            <v-icon>mdi-account-group</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-chip small color="primary" text-color="white">
                                Grupo
                              </v-chip>
                            </v-list-item-title>
                            <v-list-item-title>
                              Nome: {{ item?.grupo?.nome }}
                            </v-list-item-title>
                            <v-list-item-title>
                              Data de Criação: {{ item?.grupo?.dataCriacao }}
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              small
                              @click="removerGrupoSelecionado(index)"
                            >
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item
                          v-for="(item, index) in colaboradoresSelecionados"
                          :key="item.id || index"
                        >
                          <v-list-item-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-chip
                                small
                                color="secondary"
                                text-color="white"
                              >
                                Colaborador
                              </v-chip>
                            </v-list-item-title>
                            <v-list-item-title>
                              Nome: {{ item?.nome }}
                            </v-list-item-title>
                            <v-list-item-title>
                              Empresa: {{ item?.empresa }}
                            </v-list-item-title>
                            <v-list-item-title
                              >Cargo: {{ item?.cargo }}</v-list-item-title
                            >
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              small
                              @click="removerColaboradorSelecionado(index)"
                            >
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item-action
                          class="d-flex justify-end"
                          v-if="hasUnsavedPermissions"
                        >
                          <v-btn color="primary" @click="salvarPermissoes">
                            Salvar
                          </v-btn>
                        </v-list-item-action>
                      </v-list>
                      <div v-else class="text-center py-4">
                        Nenhuma permissão encontrada.
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item
                  ><v-card class="mb-6 card-section" outlined elevation="0">
                    <v-card-title class="section-header">
                      <v-row>
                        <v-col cols="10">
                          <v-icon color="green" class="mr-2"
                            >mdi-comment-text-outline</v-icon
                          >
                          Comentários
                          <v-chip
                            class="ml-2"
                            small
                            color="primary"
                            text-color="white"
                            >{{ comentarios.length }}</v-chip
                          >
                        </v-col>
                        <v-col cols="2" class="d-flex align-center justify-end">
                          <v-btn
                            small
                            color="primary"
                            @click="openNewComentarioDialog"
                          >
                            <v-icon color="white" left>mdi-plus</v-icon> Novo
                            comentário
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="py-0">
                      <v-list dense v-if="comentarios.length > 0">
                        <!-- Na lista de documentos vinculados -->
                        <v-list-item
                          v-for="(com, index) in paginatedComentarios"
                          :key="com.id || index"
                        >
                          <v-list-item-avatar>
                            <v-icon>mdi-account</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title
                              >Descrição: {{ com.descricao }}</v-list-item-title
                            >
                            <v-list-item-title>
                              Usuário: {{ com.usuario }}
                            </v-list-item-title>
                            <v-list-item-title
                              >Data: {{ com.data }}</v-list-item-title
                            >
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              small
                              @click="openEditComentarioDialog(com)"
                            >
                              <v-icon color="primary">mdi-pencil</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                      <div v-else class="text-center py-4">
                        Nenhum comentário encontrado.
                      </div>
                      <v-pagination
                        :total-visible="7"
                        v-if="comentarios.length > itemsPerPage"
                        v-model="comentariosPage"
                        :length="Math.ceil(comentarios.length / itemsPerPage)"
                        class="my-4"
                        color="primary"
                      />
                    </v-card-text> </v-card
                ></v-tab-item>

                <v-tab-item>
                  <v-card
                    class="mb-6 card-section"
                    outlined
                    elevation="0"
                    v-if="logs.length > 0"
                  >
                    <v-card-title class="section-header">
                      <v-icon color="green" class="mr-2">mdi-history</v-icon>
                      Histórico de Ações
                      <v-chip
                        class="ml-2"
                        small
                        color="primary"
                        text-color="white"
                        >{{ logs.length }}</v-chip
                      >
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="py-0">
                      <v-list dense>
                        <!-- Lista de logs -->
                        <v-list-item
                          v-for="(log, index) in paginatedLogs"
                          :key="log.id || index"
                        >
                          <v-list-item-avatar>
                            <v-icon>mdi-file-document-outline</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title
                              >Usuário: {{ log.usuario }}</v-list-item-title
                            >
                            <v-list-item-title
                              >Ação: {{ log.acao }}</v-list-item-title
                            >
                            <v-list-item-title
                              >Data: {{ log.data_acao }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-pagination
                        v-if="logs.length > 20"
                        v-model="logsPage"
                        :length="Math.ceil(logs.length / 20)"
                        class="my-4"
                        color="primary"
                      />
                    </v-card-text> </v-card
                ></v-tab-item>
              </v-tabs>
            </v-container>
          </base-material-card>
        </v-col>
      </v-row>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import { http } from "../../services/config";
import authHeader from "../../services/auth-header";
import rh from "../../services/rh";
import permissoesService from "../../services/permissoes";

export default {
  name: "ConsultaArquivo",
  data: () => ({
    previewUrl: null,
    previewType: null,
    permissoesDialog: false,
    showProgress: false,
    previewDialog: false,
    comentarioDialog: false,
    savingComentario: false,
    confirmDialog: false,
    confirmMessage: "",
    confirmAction: () => {},
    idDocumento: 0,
    logs: [],
    documentosVinculados: [],
    versoes: [],
    versoesPage: 1,
    novaVersaoDialog: false,
    novaVersaoArquivo: null,
    novaVersaoDescricao: "",
    salvandoVersao: false,
    headersColaboradores: [
      { text: "", value: "selecionar", sortable: false },
      { text: "Empresa", value: "empresa" },
      { text: "Nome Completo", value: "nome" },
      { text: "Departamento", value: "departamento" },
      { text: "Cargo", value: "cargo" },
    ],
    headersGrupos: [
      { text: "Nome", value: "grupo.nome" },
      { text: "Colaboradores", value: "colaboradores" },
      { text: "Data de Criação", value: "grupo.dataCriacao" },
      { text: "Modelo", value: "grupo.modelo" },
    ],
    search: "",
    tipoPermissao: "",
    comentarios: [],
    colaboradoresSelecionados: [],
    gruposSelecionados: [],
    listaColaboradores: [],
    listaGrupos: [],
    permissoes: [],
    logsPage: 1,
    comentariosPage: 1,
    documentosVinculadosPage: 1,
    versoesPage: 1,
    itemsPerPage: 5,
    editingComentario: {
      id: null,
      descricao: "",
      arquivoId: null,
      usuario: "",
      data: null,
    },
    // Snackbar
    snackbar: {
      show: false,
      text: "",
      color: "info",
      timeout: 3000,
    },
    documento: {
      id: null,
      titulo: null,
      descricao: null,
      status: null,
      tipo: null,
      palavraChave: null,
      categoria: null,
      subCategoria: null,
      departamento: null,
      empresa: null,
      usuarioInsert: null,
      dataInsert: null,
      usuarioUpdate: null,
      dataUpdate: null,
      dataValidade: null,
      dataVencimento: null,
      arquivoExterno: null,
      vinculo: null,
      identificacao: null,
    },
    semPermissao: false,
    mensagemErroPermissao: "",
  }),
  mounted() {
    window.scrollTo({
      top: 0, // Vai para o topo da página
      behavior: "smooth", // Faz o scroll ser suave
    });
    this.inicializar();
  },
  watch: {
    "$route.params.id": function (novoId, antigoId) {
      if (novoId !== antigoId) {
        this.inicializar();
      }
    },
  },
  computed: {
    paginatedComentarios() {
      const start = (this.comentariosPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.comentarios.slice(start, end);
    },
    paginatedLogs() {
      const start = (this.logsPage - 1) * 20;
      const end = start + 20;
      return this.logs.slice(start, end);
    },
    paginatedDocumentosVinculados() {
      const start = (this.documentosVinculadosPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.documentosVinculados.slice(start, end);
    },
    paginatedVersoes() {
      const start = (this.versoesPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.versoes.slice(start, end);
    },
    hasUnsavedPermissions() {
      // Verifica se há grupos sem permissaoId (não salvos ainda)
      const unsavedGrupos = this.gruposSelecionados.some(
        (grupo) => !grupo.permissaoId,
      );
      // Verifica se há colaboradores sem permissaoId (não salvos ainda)
      const unsavedColaboradores = this.colaboradoresSelecionados.some(
        (colaborador) => !colaborador.permissaoId,
      );
      // Retorna true se houver pelo menos um grupo ou colaborador não salvo
      return unsavedGrupos || unsavedColaboradores;
    },
    dataValidadeBR() {
      return this.formatarDataBR(this.documento.dataValidade);
    },
    dataVencimentoBR() {
      return this.formatarDataBR(this.documento.dataVencimento);
    },
    consultarLabelCampoChave() {
      switch (this.documento.categoria) {
        case "Contratos":
          return "Número do Contrato";
        case "Relatórios":
          return "Número do Relatório";
        case "Procedimentos":
          return "Número do Procedimento";
        case "Políticas":
          return "Número da Política";
        case "Financeiro":
          return "Número do Documento";
        case "Recursos Humanos":
          return "Número do Documento";
        case "Jurídico":
          return "Número do Documento";
        case "Técnico":
          return "Número do Documento";
        default:
          return "Número do Documento";
      }
    },
  },
  methods: {
    consultar_colaboradores() {
      rh.lista_colaboradores_ativos()
        .then((response) => {
          this.listaColaboradores = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {});
    },
    consultar_grupo_colaboradores() {
      rh.lista_grupos_colaboradorores("Arquivos", true).then((response) => {
        this.listaGrupos = response.data;
      });
    },
    removerGrupoSelecionado(index) {
      const grupo = this.gruposSelecionados[index];
      this.confirmMessage = `Deseja realmente remover o acesso do grupo "${grupo.grupo.nome}"?`;
      this.confirmAction = () => {
        // Se o grupo já foi salvo no banco de dados, exclui a permissão
        if (grupo.permissaoId) {
          this.excluirPermissao(grupo.permissaoId);
        }
        this.gruposSelecionados.splice(index, 1);
        this.confirmDialog = false;
      };
      this.confirmDialog = true;
    },
    removerColaboradorSelecionado(index) {
      const colaborador = this.colaboradoresSelecionados[index];
      this.confirmMessage = `Deseja realmente remover o acesso do colaborador "${colaborador.nome}"?`;
      this.confirmAction = () => {
        // Se o colaborador já foi salvo no banco de dados, exclui a permissão
        if (colaborador.permissaoId) {
          this.excluirPermissao(colaborador.permissaoId);
        }
        this.colaboradoresSelecionados.splice(index, 1);
        this.confirmDialog = false;
      };
      this.confirmDialog = true;
    },
    novoArquivoVinculado() {
      this.$router.push({
        path: "/novosArquivos",
        query: { idOrigem: this.idDocumento },
      });
    },
    excluirPermissao(id) {
      permissoesService
        .excluir_permissao(id)
        .then((response) => {
          this.$store.dispatch(
            "alert/success",
            "Permissão excluída com sucesso",
          );
          this.carregarPermissoes();
        })
        .catch((error) => {
          this.$store.dispatch("alert/error", "Erro ao excluir permissão");
          console.error("Erro ao excluir permissão:", error);
        });
    },
    carregarPermissoes() {
      if (!this.idDocumento) return;

      permissoesService
        .listar_permissoes_arquivo(this.idDocumento)
        .then((response) => {
          const permissoes = response.data;

          // Limpa as listas atuais
          this.gruposSelecionados = [];
          this.colaboradoresSelecionados = [];

          // Processa cada permissão
          permissoes.forEach((permissao) => {
            if (
              permissao.tipoPermissao === "GRUPO" &&
              permissao.objetoAssociado
            ) {
              // Cria um objeto no formato esperado pela interface
              const grupoObj = {
                grupo: permissao.objetoAssociado,
                colaboradores: [], // Não temos essa informação no retorno, então deixamos vazio
                permissaoId: permissao.id,
              };
              this.gruposSelecionados.push(grupoObj);

              // Atualiza a lista de grupos se o grupo ainda não estiver lá
              if (
                !this.listaGrupos.some(
                  (g) => g.grupo.id === permissao.objetoAssociado.id,
                )
              ) {
                this.listaGrupos.push({
                  grupo: permissao.objetoAssociado,
                  colaboradores: [],
                });
              }
            } else if (
              permissao.tipoPermissao === "COLABORADOR" &&
              permissao.objetoAssociado
            ) {
              // Adiciona o ID da permissão ao objeto do colaborador
              const colaboradorObj = {
                ...permissao.objetoAssociado,
                permissaoId: permissao.id,
              };
              this.colaboradoresSelecionados.push(colaboradorObj);

              // Atualiza a lista de colaboradores se o colaborador ainda não estiver lá
              if (
                !this.listaColaboradores.some(
                  (c) => c.id === permissao.objetoAssociado.id,
                )
              ) {
                this.listaColaboradores.push(permissao.objetoAssociado);
              }
            }
          });
        })
        .catch((error) => {
          console.error("Erro ao carregar permissões:", error);
        });
    },
    async salvarPermissoes() {
      // Mostra o diálogo de progresso
      this.showProgress = true;

      try {
        const promises = [];

        // Salva os grupos selecionados
        for (const grupo of this.gruposSelecionados) {
          // Verifica se o grupo já tem um ID de permissão (já foi salvo)
          if (!grupo.permissaoId) {
            const permissao = {
              arquivoId: this.idDocumento,
              tipoPermissao: "GRUPO",
              idPermissao: grupo.grupo.id,
            };

            const promise = permissoesService
              .cadastrar_permissao(permissao)
              .then((response) => {
                // Atualiza o objeto do grupo com o ID da permissão criada
                grupo.permissaoId = response.data.id;
              })
              .catch((error) => {
                console.error("Erro ao salvar permissão de grupo:", error);
              });

            promises.push(promise);
          }
        }

        // Salva os colaboradores selecionados
        for (const colaborador of this.colaboradoresSelecionados) {
          // Verifica se o colaborador já tem um ID de permissão (já foi salvo)
          if (!colaborador.permissaoId) {
            const permissao = {
              arquivoId: this.idDocumento,
              tipoPermissao: "COLABORADOR",
              idPermissao: colaborador.id,
            };

            const promise = permissoesService
              .cadastrar_permissao(permissao)
              .then((response) => {
                // Atualiza o objeto do colaborador com o ID da permissão criada
                colaborador.permissaoId = response.data.id;
              })
              .catch((error) => {
                console.error(
                  "Erro ao salvar permissão de colaborador:",
                  error,
                );
              });

            promises.push(promise);
          }
        }

        // Aguarda todas as permissões serem salvas
        await Promise.all(promises);

        // Fecha o diálogo de permissões
        this.permissoesDialog = false;

        // Recarrega as permissões para garantir que estão atualizadas
        this.carregarPermissoes();
        this.consultarLogsArquivo(this.idDocumento);
      } catch (error) {
        console.error("Erro ao salvar permissões:", error);
        this.$store.dispatch("alert/error", "Erro ao salvar permissões");
      } finally {
        // Esconde o diálogo de progresso
        this.showProgress = false;
      }
    },
    abrirArquivoVinculado(id) {
      this.$router.push(`/consultaArquivo/${id}`);
      window.scrollTo({
        top: 0, // Vai para o topo da página
        behavior: "smooth", // Faz o scroll ser suave
      });
    },
    async inicializar() {
      this.showProgress = true;
      this.idDocumento = this.$route.params.id;
      await this.consultarArquivo(this.idDocumento);
      await this.consultarVinculados(this.idDocumento);
      await this.consultarVersoes(this.idDocumento);
      await this.consultarLogsArquivo(this.idDocumento);
      await this.consultarComentarios();

      // Carrega colaboradores e grupos para as permissões
      this.consultar_colaboradores();
      this.consultar_grupo_colaboradores();

      // Carrega as permissões existentes
      this.carregarPermissoes();

      this.showProgress = false;
    },
    formatarDataBR(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "";
      const dia = String(date.getDate()).padStart(2, "0");
      const mes = String(date.getMonth() + 1).padStart(2, "0");
      const ano = date.getFullYear();
      return `${dia}/${mes}/${ano}`;
    },
    formatarDataHoraBR(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "";
      const dia = String(date.getDate()).padStart(2, "0");
      const mes = String(date.getMonth() + 1).padStart(2, "0");
      const ano = date.getFullYear();
      const hora = String(date.getHours()).padStart(2, "0");
      const minuto = String(date.getMinutes()).padStart(2, "0");
      return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    },
    async consultarLogsArquivo(id) {
      await http
        .get(`/ged/logs/${id}`, {
          headers: authHeader(),
        })
        .then((response) => {
          this.logs = response.data;
        });
    },
    async consultarVinculados(id) {
      await http
        .get(`/ged/arquivos/${id}/vinculados`, {
          headers: authHeader(),
        })
        .then((response) => {
          this.documentosVinculados = response.data;
        });
    },
    async consultarVersoes(id) {
      try {
        const response = await http.get(`/ged/arquivos/${id}/versoes`, {
          headers: authHeader(),
        });
        this.versoes = response.data || [];
        this.versoesPage = 1;
      } catch (e) {
        console.error("Erro ao carregar versões:", e);
        this.versoes = [];
      }
    },
    abrirNovaVersaoDialog() {
      this.novaVersaoDescricao = "";
      this.novaVersaoArquivo = null;
      this.novaVersaoDialog = true;
    },
    fecharNovaVersaoDialog() {
      this.novaVersaoDialog = false;
      this.novaVersaoDescricao = "";
      this.novaVersaoArquivo = null;
    },
    async cadastrarVersao() {
      if (!this.novaVersaoDescricao || !this.novaVersaoArquivo) return;
      const file = Array.isArray(this.novaVersaoArquivo)
        ? this.novaVersaoArquivo[0]
        : this.novaVersaoArquivo;
      if (!file) return;
      this.salvandoVersao = true;
      try {
        const formData = new FormData();
        const dados = { descricao: this.novaVersaoDescricao };
        formData.append(
          "dados",
          new Blob([JSON.stringify(dados)], { type: "application/json" }),
        );
        formData.append("arquivo", file);
        await http.post(`/ged/arquivos/${this.idDocumento}/versao`, formData, {
          headers: {
            ...authHeader(),
            "Content-Type": "multipart/form-data",
          },
        });
        this.fecharNovaVersaoDialog();
        await this.consultarVersoes(this.idDocumento);
        await this.consultarLogsArquivo(this.idDocumento);
      } catch (e) {
        console.error("Erro ao cadastrar versão:", e);
      } finally {
        this.salvandoVersao = false;
      }
    },
    async consultarArquivo(id) {
      try {
        const response = await http.get(`/ged/arquivos/${id}`, {
          headers: authHeader(),
        });
        this.documento = response.data;
        this.semPermissao = false;
        this.mensagemErroPermissao = "";
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.semPermissao = true;
          this.mensagemErroPermissao =
            error.response.data?.error ||
            "Você não tem permissão para acessar este arquivo";
        } else {
          console.error("Erro ao consultar arquivo:", error);
          this.showSnackbar(
            "Erro ao carregar arquivo. Tente novamente.",
            "error",
            3000,
          );
        }
      }
    },
    formatFileName(text) {
      if (!text) return "";
      const maxLength = 20;
      const fileName = typeof text === "string" ? text.split("\\").pop() : text;
      if (fileName.length <= maxLength) return fileName;
      const extension = fileName.split(".").pop();
      const name = fileName.substring(0, maxLength - extension.length - 3);
      return `${name}...${extension}`;
    },
    formatFileSize(size) {
      if (!size) return "";
      const kb = size / 1024;
      if (kb < 1024) {
        return `${kb.toFixed(2)} KB`;
      }
      const mb = kb / 1024;
      return `${mb.toFixed(2)} MB`;
    },

    // Função para converter arquivo para base64
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        if (!file) {
          resolve(null);
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Remove o prefixo (ex: "data:application/pdf;base64,") para obter apenas o base64
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
      });
    },
    voltar() {
      this.$router.push("/gestaoArquivos");
    },
    base64ToBlob(base64, mimeType) {
      const byteChars = atob(base64);
      const byteNumbers = new Array(byteChars.length);

      for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: mimeType });
    },
    canPreview(mime) {
      const previewableTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/webp",
        "image/gif",
        "text/plain",
        "text/html",
      ];

      return previewableTypes.includes(mime);
    },
    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.timeout = timeout;
      this.snackbar.show = true;
    },
    async previewFile(item) {
      this.showProgress = true;
      try {
        if (!this.canPreview(item.tipo)) {
          this.showSnackbar(
            "Esse tipo de arquivo não possui visualização.",
            "error",
            3000,
          );
          return;
        }
        const response = await http.get("/ged/download", {
          params: { arquivoExterno: item.arquivoExterno },
          headers: authHeader(),
        });

        if (response.data.id) {
          item.arquivoExterno = response.data.id;
          item.base64 = response.data.base64;
          this.previewType = response.data.tipoArquivo;
          // --- CONVERTE BASE64 PARA BLOB ---
          const blob = this.base64ToBlob(item.base64, this.previewType);
          // --- CRIA UMA URL TEMPORÁRIA PARA O IFRAME ---
          this.previewUrl = URL.createObjectURL(blob);
          // --- ABRE O DIALOG APÓS A URL SER CRIADA ---
          this.$nextTick(() => {
            this.previewDialog = true;
          });
        }
      } catch (error) {
        console.error("Erro ao carregar preview:", error);
      } finally {
        this.showProgress = false;
      }
    },

    // Métodos para gerenciar comentários
    async consultarComentarios() {
      try {
        const response = await http.get(`/ged/comentario/${this.idDocumento}`, {
          headers: authHeader(),
        });
        this.comentarios = response.data;
        this.comentariosPage = 1; // Reset para a primeira página
      } catch (error) {
        console.error("Erro ao carregar comentários:", error);
      }
    },

    openNewComentarioDialog() {
      this.editingComentario = {
        id: null,
        descricao: "",
        arquivoId: this.idDocumento,
        usuario: "",
        data: null,
      };
      this.comentarioDialog = true;
    },

    openEditComentarioDialog(comentario) {
      this.editingComentario = {
        ...comentario,
      };
      this.comentarioDialog = true;
    },

    closeComentarioDialog() {
      this.comentarioDialog = false;
      this.editingComentario = {
        id: null,
        descricao: "",
        arquivoId: null,
        usuario: "",
        data: null,
      };
    },

    async saveComentario() {
      this.savingComentario = true;

      try {
        const isEdicao = !!this.editingComentario?.id;

        const comentarioPayload = {
          descricao: this.editingComentario.descricao,
          arquivoId: Number(this.idDocumento),
        };

        if (isEdicao) {
          await this.editarComentario(
            this.editingComentario.id,
            comentarioPayload,
          );
        } else {
          await this.salvarComentario(comentarioPayload);
        }
      } catch (error) {
        console.error("Erro ao salvar comentário:", error);
      } finally {
        this.savingComentario = false;
      }
    },
    // Função interna para novo comentário
    async salvarComentario(payload) {
      await http
        .post("/ged/comentario", payload, {
          headers: authHeader(),
        })
        .then((response) => {
          console.log(response);
          this.consultarComentarios();
          this.closeComentarioDialog();
          this.consultarLogsArquivo(this.idDocumento);
        });
    },
    // Função interna para edição de comentário
    async editarComentario(id, payload) {
      await http
        .put(`/ged/comentario/${id}`, payload, {
          headers: authHeader(),
        })
        .then((response) => {
          console.log(response);
          this.consultarComentarios();
          this.closeComentarioDialog();
          this.consultarLogsArquivo(this.idDocumento);
        });
    },
    handleIframeLoad() {
      console.log("Preview carregado com sucesso");
    },

    handleIframeError() {
      console.log(
        "Erro ao carregar o preview, baixando o arquivo automaticamente",
      );
      // Fecha o dialog de preview
      this.previewDialog = false;

      // Baixa o arquivo automaticamente
      const item = {
        arquivoExterno: this.documento.arquivoExterno,
        titulo: this.documento.titulo,
        tipo: this.previewType,
      };
      this.downloadFile(item);
    },

    async downloadFile(item) {
      const id = item.arquivoExterno;
      this.showProgress = true;

      // Verificar se o ID começa com GREENDOC (ex: GREENDOC/MEMORIAL%20PARQUE%20MACEIO)
      if (id && id.startsWith("GREENDOC")) {
        // Método antigo: download via base64
        try {
          let tipo = item.tipo;
          let nome = item.nome || "arquivo";

          const response = await http.get("/ged/download", {
            params: {
              arquivoExterno: item.arquivoExterno,
            },
            headers: authHeader(),
          });

          item.base64 = response.data.base64;
          item.arquivoExterno = response.data.id;

          tipo = response.data.tipoArquivo;
          nome =
            response.data.nome || item.nomeArquivo || item.titulo || "arquivo";

          // Converte base64 para blob
          const byteCharacters = atob(item.base64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: tipo });

          // Cria URL do blob
          const url = window.URL.createObjectURL(blob);

          // Deriva extensão do tipo MIME se necessário
          const getExtensaoPorMimeType = (mimeType) => {
            const mapa = {
              "application/pdf": "pdf",
              "image/jpeg": "jpg",
              "image/png": "png",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                "docx",
              "application/msword": "doc",
              "application/vnd.ms-excel": "xls",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                "xlsx",
              "application/planilha": "xls",
              "text/plain": "txt",
              "application/zip": "zip",
            };
            return mapa[mimeType] || "bin";
          };

          // Garante nome com extensão
          const extensao = getExtensaoPorMimeType(tipo);
          const nomeBase = item.titulo || item.nomeArquivo || nome;
          const nomeFinal = `${nomeBase}.${extensao}`;

          // Cria link temporário e dispara download
          const link = document.createElement("a");
          link.href = url;
          link.download = nomeFinal;
          document.body.appendChild(link);
          link.click();

          // Limpa
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Erro ao baixar arquivo:", error);
          this.showSnackbar("Erro ao baixar arquivo.", "error", 3000);
        } finally {
          this.showProgress = false;
        }
      } else {
        // Método novo: download via Google Drive com permissões
        try {
          // TORNA PÚBLICO
          await http.patch(`/ged/arquivos/${id}/permissao`, null, {
            params: { permissao: "publico" },
            headers: authHeader(),
          });

          // MONTA URL OFICIAL
          const downloadUrl = `https://drive.google.com/uc?export=download&id=${id}`;

          // ABRE DOWNLOAD
          window.open(downloadUrl, "_blank");

          // ESPERA O DRIVE PROCESSAR (IMPORTANTE)
          setTimeout(async () => {
            try {
              await http.patch(`/ged/arquivos/${id}/permissao`, null, {
                params: { permissao: "privado" },
                headers: authHeader(),
              });
            } catch (e) {
              console.error("Erro ao voltar arquivo para privado", e);
            }
          }, 30000); // 30 segundos
        } catch (error) {
          console.error("Erro no fluxo de download:", error);
          this.showSnackbar("Erro ao preparar download do arquivo.", "error", 3000);
        } finally {
          this.showProgress = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.preview-dialog {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.preview-toolbar {
  flex: 0 0 auto;
}

.preview-content {
  flex: 1 1 auto;
  position: relative;
  height: calc(100vh - 64px);
}

.preview-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.card-section {
  border-radius: 12px;
}

.section-header {
  padding: 16px 20px;
  border-radius: 12px 12px 0 0;
}
.item-divisor {
  border-top: 1px solid #e0e0e0;
}
.v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
  font-weight: 500 !important;
  border-radius: 8px;
}

.v-text-field--outlined >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}

.v-text-field--outlined >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}

.v-textarea--outlined >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}

.v-file-input >>> .v-input__control > .v-input__slot {
  border-radius: 8px;
}

.v-alert {
  border-radius: 8px;
}
</style>
